import * as THREE from "three";
import { logger } from "../utils/logger";

export function setNdcPointerFromEvent(
  pointer: THREE.Vector2,
  event: PointerEvent,
  rendererDom: HTMLElement
): void {
  const rect = rendererDom.getBoundingClientRect();
  const x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
  const y = -(((event.clientY - rect.top) / rect.height) * 2 - 1);
  pointer.set(x, y);
}

export function dispatchPositionGizmoDragEvent(
  type: "position-gizmo-drag" | "position-gizmo-drag-end",
  detail: Record<string, unknown> | null
): void {
  try {
    window.dispatchEvent(new CustomEvent(type, { detail: detail || {} }));
  } catch (error) {
    logger.warn("[PositionGizmo] Failed to dispatch drag event", error);
  }
}
